import { render, staticRenderFns } from "./CouponDialogFooter.vue?vue&type=template&id=be3ef438&"
import script from "./CouponDialogFooter.vue?vue&type=script&lang=ts&"
export * from "./CouponDialogFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports